'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'

// lib
import { accessibilityRole } from '../_support'
import Box, { BoxProps } from '../box'

/* -----------------------------------------------------------------------------
 * Form helpers
 * Small helpers to ensure forms are built with consistent spacing
 * -------------------------------------------------------------------------- */

export type FormRowProps = BoxProps & {}
export const FormRow = (props: FormRowProps) => <Box mb='08' {...props} />

export type FormFooterProps = BoxProps & {}
export const FormFooter = (props: FormRowProps) => <Box mt='16' {...props} />

/* -----------------------------------------------------------------------------
 * Form
 * -------------------------------------------------------------------------- */

export type FormProps = BoxProps & {}

const Form = (props: FormProps) => {
  const ref = React.useRef<HTMLElement>(null)
  // the form only exists for semantics: Formik submits it, the browser must not
  React.useEffect(() => {
    const node = ref.current
    if (!node) return
    const preventSubmit = (event: Event) => event.preventDefault()
    node.addEventListener('submit', preventSubmit)
    return () => node.removeEventListener('submit', preventSubmit)
  }, [])

  return (
    <Box ref={ref} accessibilityRole={accessibilityRole('form')} {...props} />
  )
}

export default Form
